import React, { Component } from 'react';

import FeatureItem from "./FeatureItem";

export default class Features extends Component {

    constructor(props) {
        super();

        this.state = {};
    }

    render() {
        const debug = this.props.debug;

        return (
            <div className="features">
                {/*<h3>{this.props.title} Features</h3>*/}
                <table>
                    <tbody>
                        {this.props.features.map((feature, index) => (
                            (feature.visible === undefined || feature.visible === true) &&
                            <FeatureItem extDisable={this.props.extDisable} configurationId={this.props.configurationId} key={index} feature={feature} debug={debug} updateConfiguration={this.props.updateConfiguration} handleLock={this.props.handleLock} showError={this.props.showError} />
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}